module.exports = __webpack_public_path__ + "media/customizations/ontopoftheworld/logo-c2a16055748a93bcc6a80c01d6cffb8e.png";